import type { BookingDetails } from '@/types/form';

import { useForm } from '@/services/form';
import { ref } from 'vue';

export const alternative = ref<boolean>(false);

export const { form, errors, setErrors, clearForm } = useForm<BookingDetails>({
  accommodation_id: 0,
  room_id: '',
  flight_id: 0,
  startdate: '',
  duration: '',
  terms: false,
  address: '',
  carrental: false,
  country: 'The Netherlands',
  date_of_birth: '',
  email: '',
  email_repeat: '',
  first_name: '',
  last_name: '',
  insurance: false,
  passengers: [],
  phone: '',
  place: '',
  title: 'Dhr',
  zipcode: '',
  extras: [],
  brand: 2,
  skipass_id: '',
});
